import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/shared/user.service';
import { Contract } from '../../shared/contract.model';
import { Table } from 'primeng/table';


interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements AfterViewInit {
  @ViewChild('dt1') dt1: Table;
  @ViewChild('dt2') dt2: Table;
   @ViewChild('dt3') dt3: Table;
   @ViewChild('dt4') dt4: Table;
  disableTile :boolean = true
  ActiveTileIndication: number = 0;
  statusLabel: any[] = [];
  statusValue: any[] = [];
  chart: any;
  columnmessege = "Approval request assigned for";
  loading: boolean = true;
  stagnant: [] = [];
  expried: [] = [];
  cols!: Column[];
  expire!: Column[];
  selectedExpColumns!: Column[];
  selectedColumns!: Column[];
  pendingApprove:[]=[]
  pendingApp!:Column[]
  selectedApprove!: Column[];
  pendingReview:[]=[]
  pendingReviews!:Column[]
  selectedReview!: Column[];
  activeTtile = 'active-tile'
  
  constructor(
    private cd: ChangeDetectorRef,
    public toast: ToastrService,
    public userService: UserService
  ) { }

  ngOnInit() {
    this.userService.getStagnantContract(5).then((res: any) => {
      this.stagnant = res.body;
      this.stagnant.forEach((data: any) => {
        data.startDate = data.startDate ? moment(data.startDate).format("lll") : '';
        data.lastUpdatedDate = data.lastUpdatedDate ? moment(data.lastUpdatedDate).format("lll") : '';
      });
    });

    this.userService.getExpiredContract(90).then((res: any) => {
      this.expried = res.body;
      this.expried.forEach((data: any) => {
        data.startDate = data.startDate ? moment(data.startDate).format("ll") : '';
        data.expiryDate = data.expiryDate ? moment(data.expiryDate).format("ll") : '';
      });
    });
    this.userService.getAllContractsForApproval().then((res:any)=>{
      this.pendingApprove = res
      this.pendingApprove.forEach((data:any)=>{
        data.createdDate = data.createdDate ? moment(data.createdDate).format("ll") : '';
        // data.updatedDate = data.updatedDate ? moment(data.updatedDate).format("lll") : '';
      })

    });
    this.userService.getAllContractsForReview().then((res:any)=>{
      this.pendingReview = res
      this.pendingReview.forEach((data:any)=>{
        data.createdDate = data.createdDate ? moment(data.createdDate).format("ll") : '';
        // data.updatedDate = data.updatedDate ? moment(data.updatedDate).format("lll") : '';
      })
    })

    this.cols = [
      { field: 'contractName', header: 'Contract Name' },
      { field: 'contractType', header: 'Contract Type' },
      { field: 'partyName', header: 'Party Name' },
      { field: 'startDate', header: 'Start Date' },
      { field: 'lastUpdatedDate', header: 'Last Update Date' },
      { field: 'totalAgreementValue', header: 'Total Agreement Value' },
      { field: 'contractStatus', header: 'Contract Status' },
    ];

    this.selectedColumns = this.cols;

    this.expire = [
      { field: 'name', header: 'Contract Name' },
      { field: 'partyName', header: 'Party Name' },
      { field: 'startDate', header: 'Start Date' },
      { field: 'expiryDate', header: 'Expired Date' },
      { field: 'contractAmount', header: 'Total Agreement Value' }
    ];

    this.selectedExpColumns = this.expire;
    this.pendingApp= [
      { field: 'name', header: 'Contract Name' },
      { field: 'contractType', header: 'Contract Type' },
      { field: 'createdDate', header: 'Start Date' },
      { field: 'updatedDate', header: 'Updated Date' },
      { field: 'contractStatus', header: 'Contract Status' },

    ]
    this.selectedApprove = this.pendingApp
    this.pendingReviews = [
      { field: 'name', header: 'Contract Name' },
      { field: 'contractType', header: 'Contract Type' },
      { field: 'createdDate', header: 'Start Date' },
      { field: 'updatedDate', header: 'Update Date' },
      { field: 'contractStatus', header: 'Contract Status'},

    ]
  this.selectedReview=this.pendingReviews
  }

  ngAfterViewInit(): void {

  }

  customFilter(value: any, filter: any): boolean {
    // Implement your custom filtering logic here
    // For example, filtering based on a specific condition
    return value === filter;
  }
  
  getContractsCommanly(x: number = 0) {
    this.ActiveTileIndication = x;
    switch (x) {
      case 0:
        this.columnmessege = 'a'; break;
      case 1:
        this.columnmessege = 'b'; break;
      case 2:
        this.columnmessege = 'c'; break;
      case 3:
        this.columnmessege = 'd';
        this.disableTile = true;
         break;

      case 4:
        this.columnmessege = 'e'; break;
      case 5:
        this.columnmessege = 'f'; break;
      case 6:
        this.columnmessege = 'g'; break;
      case 7:
        this.disableTile = true;
        this.columnmessege = 'h';
         break;
      case 8:
        this.disableTile = true;
        this.columnmessege = 'i';
         break;
    }
  }

  
  exportExcel(data: any[], fileName: string) {
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, fileName);
    });
  }
  

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
  
  exportStagnantContracts() {
    const renderedData = this.dt1.filteredValue || this.dt1.value;
    const dataToExport = renderedData.map(item => {
      return {
        'Contract Name': item.contractName,
        'Contract Type':item.contractType,
        'Party Name': item.partyName,
        'Start Date': item.createdDate,
        'Last Update Date': item.lastUpdatedDate,
        'Total Agreement Value': item.totalAgreementValue,
        'Contract Status':item.contractStatus
      };
    });
  this.exportExcel(dataToExport,'stagnant_contracts');
}

exportExpiredContracts() {
  const renderedData = this.dt2.filteredValue || this.dt2.value;
  const dataToExport = renderedData.map(item => {
    return {
      'Contract Name': item.name,
      'Party Name': item.partyName,
      'Start Date': item.createdDate,
      'Expired Date': item.expiryDate,
      'Total Agreement Value': item.contractAmount
    };
  });
  this.exportExcel(dataToExport,'Pending_Expiry_contract')

}

 exportPendingReview(){
  const renderedData = this.dt4.filteredValue || this.dt4.value;
  const dataToExport = renderedData.map(item => {
    return {
      'Contract Name': item.name,
      'Contract Type': item.contractType,
      'Start Date': item.createdDate,
      'Updated Date': item.updatedDate,
      'Contract Status': item.contractStatus
    };
  });
  this.exportExcel(dataToExport,'Pending_review_contract')
 }
 exportPendingApproval() {
  const renderedData = this.dt3.filteredValue || this.dt3.value;
  const dataToExport = renderedData.map(item => {
    return {
      'Contract Name': item.name,
      'Contract Type': item.contractType,
      'Start Date': item.createdDate,
      'Updated Date': item.updatedDate,
      'Contract Status': item.contractStatus
    };
  });

  this.exportExcel(dataToExport, 'pending_approval_contracts');
}
}
